import React, { useEffect, useMemo, useState } from 'react';
import * as styles from './HomeV2.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Location from '../../../components/Location/Location';
import RedNumberText from '../../../components/RedNumberText/RedNumberText';
import LinkCardV1 from '../../../components/LinkCard/V1/LinkCardV1';
import {
  formatIncrementedValue,
  formatLinksV2 as formatLinks,
} from '../helpers';

const HomeV2 = ({ pageContext }) => {
  const [subheader, setSubheader] = useState(
    formatIncrementedValue(pageContext.data.V2_Subheader)
  );

  const initialLinks = useMemo(() => formatLinks(pageContext), [pageContext]);
  const [links, setLinks] = useState(initialLinks);

  useEffect(() => {
    const timeout1 = setTimeout(() => {
      setLinks(formatLinks(pageContext, -1));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -1));
    }, 1 * 1000);

    const timeout2 = setTimeout(() => {
      setLinks(formatLinks(pageContext, -2));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -2));
    }, 3 * 1000);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  const backgroundImage = useMemo(
    () =>
      getImage(
        pageContext.data.V2BackgroundImage?.localFiles?.[0]?.childImageSharp
      ),
    [pageContext.data.V2BackgroundImage]
  );

  const coverImage = useMemo(
    () =>
      getImage(
        pageContext.data.Cover_Photo_Desktop?.localFiles?.[0]?.childImageSharp
      ),
    [pageContext.data.Cover_Photo_Desktop]
  );

  return (
    <div className={styles.container}>
      <div
        className={styles.mainCard}
        style={{
          backgroundColor: !pageContext.data.V2BackgroundImage
            ? pageContext.data.V2BackgroundColor ?? '#33aa331a'
            : 'transparent',
        }}
      >
        {backgroundImage && (
          <GatsbyImage
            image={backgroundImage}
            alt="Background image"
            className={styles.backgroundImage}
          />
        )}

        <div className={styles.content}>
          {coverImage && (
            <GatsbyImage
              image={coverImage}
              alt="Cover Photo Mobile"
              className={styles.profilePhoto}
            />
          )}

          <h1 className={styles.headerTitle}>{pageContext.data.Full_Name}</h1>
          <h2 className={styles.subHeader}>
            <RedNumberText {...subheader} />
          </h2>

          {pageContext.data.V2Location && <Location />}

          <div className={styles.links}>
            {links.map((l) => (
              <LinkCardV1
                key={l.platform}
                icon={l.icon}
                platform={l.platform}
                platformTitle={l.platformTitle}
                url={l.link}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeV2;
